import Vue from 'vue';
import VueI18n from 'vue-i18n';
// Translations
import en from '@/translations/en.json';

Vue.use(VueI18n);

const messages = {
  en,
};

const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
localStorage.setItem('lang', lang);

const i18n = new VueI18n({
  locale: lang,
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js